export default {"src":"/_next/static/media/bb-baguette.34862778.svg","height":486,"width":486,"blurWidth":0,"blurHeight":0};